import { render } from "./closedTickets.vue?vue&type=template&id=6b00cf36&scoped=true"
import script from "./closedTickets.vue?vue&type=script&lang=js"
export * from "./closedTickets.vue?vue&type=script&lang=js"

import "./closedTickets.vue?vue&type=style&index=0&id=6b00cf36&scoped=true&lang=scss"
import "./closedTickets.vue?vue&type=style&index=1&id=6b00cf36&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b00cf36"]])

export default __exports__